/**
 * Franchise brands serve every branch under its own path: https://<brand>.menulynx.com/<branch>.
 * Before the router mounts, the first path segment is a *candidate*; GET /settings?branch=
 * decides whether it is a real branch. Same slug rule as the backend (branch_model.py).
 */
const SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/;

// App routes, plus the paths the backend reserves (a branch can never be called this).
const NOT_BRANCHES = new Set(['categories', 'items', 'images', 'static', 'settings']);

export function resolveBranchCandidate(pathname: string): string | null {
  const seg = pathname.split('/')[1] || '';
  return SLUG_RE.test(seg) && !NOT_BRANCHES.has(seg) ? seg : null;
}
